import { createFileRoute } from "@tanstack/react-router";

import type { FriendsTab } from "~/features/friends/types/friendsTypes.ts";
import FriendsPage from "~/pages/friends/FriendsPage.tsx";

type FriendsSearchParams = {
    tab?: FriendsTab;
};

export const Route = createFileRoute("/_auth/friends/")({
    validateSearch: (search: Record<string, unknown>): FriendsSearchParams => ({
        tab: search.tab === "teams" ? "teams" : undefined,
    }),
    component: FriendsPage,
});
